export enum ChallengeType {
  COMPETITIVE_CHALLENGE = "CHALLENGE_TYPE_COMPETITIVE_CHALLENGE",
  CUSTOM_CHALLENGE = "CHALLENGE_TYPE_CUSTOM_CHALLENGE",
}
